<script>
	export let block;
	export let data;
	export let index;
	export let j;
	export let type = "";

	import {
		isMobile,
		saved,
		changed,
		isNewDataChanged,
	} from "../../../../../stores/variables";
	import { request } from "../../../../../scripts/request";
	import { cloneDeep } from "lodash-es";

	let opened;

	$: if ($saved) {
		if ($saved === "saved") {
			opened = false;
			if (
				data[data.field_name] &&
				data[data.field_name][index] &&
				data[data.field_name][index].active
			) {
				$isNewDataChanged = true;
				block.newData[block.field_name] = block.ranks;
				data[data.field_name][index][j] = block;
				data.loadedData[index][block.field_name] =
					block.ranks.join(",");
				data.loadedData[index]["toUpdate"] = true;

				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.loadedData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp["ID"] == data.loadedData[index]["ID"])
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.loadedData[index]
						);
						check = false;
					}
				}
			}
			if (
				data[data.field_name + "_new"] &&
				data[data.field_name + "_new"][index] &&
				data[data.field_name + "_new"][index].active
			) {
				$isNewDataChanged = true;
				if (block.ranks) {
					block.newData[block.field_name] = block.ranks;
					data.createdData[index][block.field_name] =
						block.ranks.join(",");
				} else {
					block.newData[block.field_name] = "";
					data.createdData[index][block.field_name] = "";
				}
				data[data.field_name + "_new"][index][j] = block;
				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.createdData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp.temp_id == data.createdData[index].temp_id)
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.createdData[index]
						);
						check = false;
					}
				}
			}
		}
		if ($saved === "canceled") {
			block.options = block.before.options;
			block.values = block.before.values;
			block.ranks = block.before.ranks;
			block.newData[block.field_name] = block.before.ranks;
			if (block.ranks == block.upl_ranks) {
				$isNewDataChanged = false;
			}
			opened = false;
		}
	}

	if (!block.newData) block.newData = [];
	if (!block.list) block.list = [];
	if (!block.values) block.values = [];

	if (block.newData) {
		if (block.newData[block.field_name]) {
			block.ranks = block.newData[block.field_name].ranks.split(",");
			block.upl_ranks = cloneDeep(block.ranks);
			block.list = Object.values(block.newData[block.field_name].list);
			block.options = [];
			block.list.forEach((rank) => {
				block.options.push(rank);
			});
			block.list.forEach((rank, i) => {
				block.ranks.forEach((rank_index) => {
					if (i + 1 == rank_index) {
						block.values.push(rank);
					}
				});
			});
			block.options.forEach((option, i) => {
				block.values.forEach((value) => {
					if (option == value) {
						delete block.options[i];
					}
				});
			});
			block.options = Object.values(block.options);
			block.newData[block.field_name] = block.ranks;
			if (block.newData[block.field_name] && block.ranks.length > 0) {
				data.loadedData[index][block.field_name] =
					block.ranks.join(",");
			}
			delete block.newData[block.field_name].list;
			delete block.newData[block.field_name].ranks;
		} else {
			block.ranks = [];
			let d = {
				field_name: block.field_name,
			};
			let req = request.fetchData(
				"servicesdata",
				"servicesdata" + block.field_name,
				d
			);
			if (req) {
				req.then((result) => {
					let res = result.data;
					if (typeof res === "object") {
						res = Object.values(res);
					}
					block.list = res;
					block.options = [];
					block.list.forEach((rank) => {
						block.options.push(rank);
					});
					block.list.forEach((rank, i) => {
						block.ranks.forEach((rank_index) => {
							if (i + 1 == rank_index) {
								block.values.push(rank);
							}
						});
					});
					block.options.forEach((option, i) => {
						block.values.forEach((value) => {
							if (option == value) {
								delete block.options[i];
							}
						});
					});
					block.options = Object.values(block.options);
					block.newData[block.field_name] = block.ranks;
					if (
						block.newData[block.field_name] &&
						block.ranks.length > 0
					) {
						data.loadedData[index][block.field_name] =
							block.ranks.join(",");
					}
					delete block.newData[block.field_name].list;
					delete block.newData[block.field_name].ranks;
				});
			}
		}
	}

	// if (block.newData) {
	// 	if (!block.ranks) {
	// 		if (block.newData[block.field_name]) {
	// 			block.ranks = block.newData[block.field_name].ranks.split(",");
	// 			block.list = Object.values(
	// 				block.newData[block.field_name].list
	// 			);
	// 		} else {
	// 			block.ranks = [];
	// 			block.list = [
	// 				"Кандидат наук",
	// 				"Доктор наук",
	// 				"Доцент",
	// 				"Профессор",
	// 				"Врач первой категории",
	// 				"Врач второй категории",
	// 				"Врач высшей категории",
	// 			];
	// 		}
	// 		block.options = [];
	// 		block.list.forEach((rank) => {
	// 			block.options.push(rank);
	// 		});
	// 		block.list.forEach((rank, i) => {
	// 			block.ranks.forEach((rank_index) => {
	// 				if (i + 1 == rank_index) {
	// 					block.values.push(rank);
	// 				}
	// 			});
	// 		});
	// 		block.options.forEach((option, i) => {
	// 			block.values.forEach((value) => {
	// 				if (option == value) {
	// 					delete block.options[i];
	// 				}
	// 			});
	// 		});
	// 		block.options = Object.values(block.options);
	// 		block.newData[block.field_name] = block.ranks;
	// 		data.loadedData[index][block.field_name] = block.ranks.join(",");
	// 		delete block.newData[block.field_name].list;
	// 		delete block.newData[block.field_name].ranks;
	// 	}
	// }

	function handleIn(i) {
		$changed = "1";
		$isNewDataChanged = true;
		let temp = block.options.splice(i, 1);
		block.list.forEach((rank, i) => {
			if (rank == temp) {
				block.ranks.push(i + 1 + "");
				block.ranks.sort();
			}
		});
		block.options = block.options;
		block.values = block.values.concat(temp);
	}

	function handleOut(i) {
		$changed = "1";
		$isNewDataChanged = true;
		let temp = block.values.splice(i, 1);
		block.list.forEach((rank, i) => {
			if (rank == temp) {
				block.ranks.forEach((value, j) => {
					if (i + 1 == value) {
						block.ranks.splice(j, 1);
						block.ranks.sort();
					}
				});
			}
		});
		block.values = block.values;
		block.options = block.options.concat(temp);
	}

	function close() {
		block.active = !block.active;
		let container = this.parentNode;

		function temp(e) {
			if (e.target.parentNode != container) {
				block.active = false;
				document.body.removeEventListener("click", temp);
			}
		}
		document.body.addEventListener("click", temp);
	}

	$: if (!opened) {
		opened = "1";
		if (!block.before) block.before = {};
		block.before.values = cloneDeep(block.values);
		block.before.ranks = cloneDeep(block.ranks);
		block.before.options = cloneDeep(block.options);
		// let first;
		// block.ranks.forEach((rank, i) => {
		// 	block.values.forEach((value) => {
		// 		if (rank == value) {
		// 			if (!first) {
		// 				first = "1";
		// 				block.before.ranks = i + 1 + "";
		// 			} else {
		// 				block.before.ranks += "," + (i + 1);
		// 			}
		// 		}
		// 	});
		// });
	}
</script>

{#if block}
	<div class="modal__item-name">
		{block.name ? block.name : ""}
	</div>
	<div class="content {block.options ? 'dropdown' : ''}">
		<div>
			{#if block.values}
				{#each block.values as value, i}
					<span
						>{value}<i
							class="fas fa-times"
							on:click={() => handleOut(i)}
						/></span
					>
				{/each}
			{:else}
				{block.placeholder}
			{/if}
		</div>
		<b on:click={close} />

		{#if block.active}
			{#if block.options}
				<ul class={$isMobile ? "mobile" : "not_mobile"}>
					{#each block.options as item, i}
						<li on:click={() => handleIn(i)}>
							{item}
						</li>
					{/each}
				</ul>
			{/if}
		{/if}
	</div>
{/if}

<style lang="scss">
	.content {
		display: flex;
		width: 100%;
		position: relative;
		padding: 18px 20px;
		cursor: pointer;

		&.dropdown::before {
			content: "";
			position: absolute;
			align-self: center;
			display: flex;
			margin-left: auto;
			width: 10px;
			height: 10px;
			border: solid 3px var(--color-1);
			border-top: 0;
			border-right: 0;
			order: 100;
			transform: rotate(-45deg);
			transition: all 0.1s ease;
			margin-top: -2px;
			right: 23px;
		}

		> b {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}

		> div {
			margin: 0 -5px -5px 0;
			padding-right: 35px;
			display: flex;
			flex-grow: 1;
			flex-wrap: wrap;
			position: relative;

			> span {
				padding: 3px 5px;
				margin: 0 5px 5px 0;
				color: var(--text-black-1);
				border: solid 1px var(--border-gray-1);
				border-radius: 3px;
				display: flex;
				align-items: center;

				@media (max-width: 700px) {
					flex-grow: 1;
				}

				&:hover {
					> i {
						opacity: 1;
					}
				}

				> i {
					transition: all 0.2s ease-in;
					opacity: 0.5;
					margin-left: auto;
					font-weight: 100;
					z-index: 1;

					&::before {
						margin-left: 5px;
					}
				}
			}
		}

		> ul {
			display: flex;
			flex-direction: column;
			position: absolute;
			z-index: 1;
			width: 100%;
			background-color: var(--bg-main-1);
			top: 100%;
			left: 0;
			max-height: 150px;
			overflow: auto;
			border: solid 1px var(--border-gray-1);
			z-index: 2;

			&.not_mobile::-webkit-scrollbar {
				width: 12px;
				height: 12px;
			}

			&::-webkit-scrollbar {
				width: 0px;
				height: 0px;

				&-track {
					background: var(--bg-main-1);
					box-shadow: 0 0 2px hsla(0, 0%, 0%, 0.2);
				}

				&-thumb {
					background: var(--color-1);
					border-radius: 8px;
					transition: background-color 0.2s ease;
					border: 3px solid var(--bg-main-1);
				}
			}

			> li {
				display: flex;
				padding: 5px 20px;
			}
		}
	}
</style>
